module.exports = __webpack_public_path__ + "media/img/vca/vca-2022-1d81a52b00fc1df3cd83a318ab415d0e.png";